import {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import Toast from '../component/Toast';
import {callIfFunc} from '../function';
import useEffectAfterTrue from '../hook/useEffectAfterTrue';
import useTypedSelector from '../hook/useTypedSelector';
import {DEFAULT_ANIMATION_DURATION} from '../scss/util/variable';
import {actions} from '../state/action';
import {getClientStore} from '../store';
import {IToast, Translator} from '../type';

enum ToastState {
  Open,
  Closing,
  Closed,
}

export default function PToast() {
  const toast = useTypedSelector(state =>
    state.common.toasts.length ? state.common.toasts[0] : undefined
  );
  const [toastState, setToastState] = useState(
    toast ? ToastState.Open : ToastState.Closed
  );

  useEffectAfterTrue(
    () => setToastState(ToastState.Open),
    toastState === ToastState.Closed && !!toast
  );

  useEffect(() => {
    if (toastState !== ToastState.Open) {
      return;
    }
    const id = setTimeout(
      () => {
        setToastState(ToastState.Closing);
      },
      (toast && toast.showingDuration) || DEFAULT_DURATION
    );
    return () => clearTimeout(id);
  }, [toastState, toast]);

  const dispatch = useDispatch();
  useEffectAfterTrue(() => {
    const id = setTimeout(() => {
      setToastState(ToastState.Closed);
      dispatch(actions.removeToast());
    }, DEFAULT_ANIMATION_DURATION);
    return () => clearTimeout(id);
  }, toastState === ToastState.Closing);

  return toast ? (
    <div
      className={cn(
        'flex pointer-events-none fixed top-1/2 -translate-y-1/2 z-toast w-full px-30',
        {
          'top-22': toast.variant === 'transparent',
        }
      )}
    >
      <Toast
        title={toast.title}
        desc={toast.desc}
        isClosing={toastState === ToastState.Closing}
        variant={toast.variant}
        src={toast.src}
      />
    </div>
  ) : null;
}

interface IPToastParam extends Omit<IToast, 'title' | 'desc'> {
  title?: string | Translator;
  desc: string | Translator;
}
export function pToast(params: IPToastParam | string | Translator) {
  const pStore = getClientStore()!;
  if (typeof params === 'string' || typeof params === 'function') {
    pStore.dispatch(
      actions.addToast({
        desc: callIfFunc(params, pStore.getState().common.tFunction),
      })
    );
  } else {
    const {title, desc, ...props} = params;
    const t = pStore.getState().common.tFunction;
    pStore.dispatch(
      actions.addToast({
        ...props,
        title: callIfFunc(title, t),
        desc: callIfFunc(desc, t),
      })
    );
  }
}

const DEFAULT_DURATION = 2000;
